/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef, useMemo, useLayoutEffect } from "react";
import moment from "moment";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, MenuItem, Dialog, Button, ButtonGroup, IconButton, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { getInvoiceForm, getVehicle, getSaleType, getFlight, getAircraft, getInventory, postConversion, createAirInv, getProduct, getCurrency } from "../../../services/api";
import { FilterBy } from "../../commons/filter.component";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import InvoicePreview from "./invPreview";
import { sumOfField } from "../../../services/libService";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import CustomDatePicker from "../../commons/CustomDatePicker";

const initialProduct = {
  vehicle: null,
  // refueler_no: null,
  hydrant_sys: "", //nhap
  position_no: "", //nhap
  driver: "", //nhap
  cert_no: "", //nhap
  meter_before_pump: "", //nhap
  meter_after_pump: "", //nhap
  product_id: null,
  product_name: null,
  productunit_id: null,
  product_unit: null,
  unit: 21,
  density: "", //nhap
  temp: "", //nhap
  d15: "",
  vcf: "",
  wcf: "",
  l15: "",
  kg: "",
  lit: "",
  gallon: "",
  quantity: null,
  price_unit: null,
  amount: null,
  price_id: null,
  // vehicle_id: null,
  price_no: null,
};
const initialInputData = {
  form: null,
  customer: null,
  valid_date: moment(Date.now()).format("YYYY-MM-DD"),
  inventory: null,
  saleorder: null,
  contract_no: "",
  saletype: null,
  contract_date: moment(Date.now()).format("YYYY-MM-DD"),
  cert_no: null,
  vehicle: null,
  transport_company: null,
  driver: null,
  route: null,
  note: "",
  customs_declaration: "",
  airline: null,
  addhoc_shippedTo: "",
  flight: null,
  start_time: moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"),
  end_time: moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"),
  code_aircraft: "",
  aircraft_type: null,
  invoiceproducts: [initialProduct],
  method: 1,
  currency: null,
  price_unit: "",
  product: null,

  //
  field0: null,
  field1: null,
  field2: null,
  field3: null,
  field4: null,
  field5: null,
  field6: null,
  field7: null,
  field8: null,
  field9: null,
  field10: null,
  field11: null,
  field12: null,
  field13: null,
  field14: null,
  field15: null,
  field16: null,
  field17: null,
};
function CreateOtherInvoice() {
  //boiler plate
  const [t] = useTranslation();
  const productRef = useRef();
  const location = useLocation();
  //state
  const [inputData, setInputData] = useState(initialInputData);
  const [dialogOpen, setDialogOpen] = useState(false);
  const dataForPreview = useMemo(() => {
    return {
      serial: inputData.form,
      product_name: inputData.product?.name,
      product_unit: "US Gallon",
      price_unit: inputData.price_unit,
      invoiceproducts: inputData.invoiceproducts.map((item) => ({
        quantity: item.gallon,
        amount: inputData.price_unit * item.gallon,
        gallon: item.gallon,
        lit: item.lit,
        temp: item.temp,
        density: (item.density && item.density / 10000) || "",
        kg: item.kg,
      })),
      sub_total: inputData.price_unit * sumOfField(inputData.invoiceproducts, "gallon"),
      note: inputData.note,
      valid_date: inputData.valid_date,
      selectedCustomer: inputData.customer,
      vat_rate: inputData.saletype?.id === 3 ? 10 : 0, // neu saletype = noi dia thi thue 10%
      currency: inputData.currency,
      aircraft_no: inputData.code_aircraft,
      selectedFlight: inputData.flight,
      refueler_no: inputData.invoiceproducts[0].vehicle?.license_plate,
      selectedVehicle: inputData.invoiceproducts[0].vehicle,
      position_no: inputData.invoiceproducts[0].position_no,
      startMeter: inputData.invoiceproducts[0].meter_before_pump,
      endMeter: inputData.invoiceproducts[0].meter_after_pump,
      starttime_field: inputData.start_time,
      endtime_field: inputData.end_time,
      cert_no: inputData.invoiceproducts[0].cert_no,
    };
  }, [inputData]);

  //redux state
  const user = useSelector((state) => state.user.data);

  //method
  const handleSubmit = () => {
    // let sub_quantity = sumOfField(inputData.invoiceproducts, priceData.unit.id === 22 ? 'gallon' : 'lit')
    // let sub_amount = sub_quantity * priceData.price.price_without_tax
    // let vat = priceData && priceData.price.vat_rate * sub_amount/100
    let object = {
      formno: inputData.form?.form,
      serial: inputData.form?.series,
      invoiceform_id: inputData.form?.id,
      saletype_id: inputData.saletype,
      currency: inputData.currency?.code,
      valid_date: inputData.valid_date,
      customer_id: inputData.customer?.id,
      customer_name: inputData.customer?.name,
      customer_tax: inputData.customer?.tax_code,
      customer_address: inputData.customer?.address,
      shipped_to: inputData.saleorder?.shipped_to,
      adhoc_shippedto: inputData.addhoc_shippedTo,

      inventory_id: inputData.inventory?.id,
      customdoc_id: null,
      customoffice_id: null,
      flight_id: inputData.flight?.id,
      flight_no: inputData.flight?.flight_no,
      route: inputData.flight?.route,
      aircraft_id: inputData.aircraft_type?.id,
      code_aircraft: inputData.code_aircraft,
      hydrant_sys: inputData.inventory?.whtype,
      start_pump: moment(inputData.start_time).format("YYYY-MM-DD HH:mm"),
      end_pump: moment(inputData.end_time).format("YYYY-MM-DD HH:mm"),

      // sub_quantity,
      sub_lit: sumOfField(inputData.invoiceproducts, "lit"),
      sub_l15: sumOfField(inputData.invoiceproducts, "l15"),
      sub_kg: sumOfField(inputData.invoiceproducts, "kg"),
      sub_usg: sumOfField(inputData.invoiceproducts, "gallon"),
      note: inputData.note,
      so_id: inputData.saleorder?.id,
      bank_id: inputData.saleorder?.bank,

      products: inputData.invoiceproducts.map((item) => ({
        lit: item.lit,
        density: item.density / 10000,
        temp: item.temp,
        gallon: item.gallon,
        position_no: item.position_no,
        refueler_no: item.vehicle?.license_plate,
        meter_before_pump: item.meter_before_pump,
        meter_after_pump: item.meter_after_pump,
        // amount: priceData?.price?.price_without_tax  * (priceData?.unit?.shortname === 'USG' ? item.gallon : item.lit),
        // productunit_id: priceData?.unit?.id,
        // product_id: priceData?.product?.id,
        vehicle_id: item.vehicle?.id,
        cert_no: item.cert_no,
        // date_contract:
      })),
    };
    console.log("sending data: ", object);
    return createAirInv(object);
  };

  // effect
  useEffect(() => {
    productRef.current = inputData.invoiceproducts;
  }, [inputData.invoiceproducts]);
  useLayoutEffect(() => {
    if (!location) return;
  }, [location]);
  return (
    <div>
      <h1>{t("Tạo hóa đơn khác")}</h1>
      <Grid container spacing={2}>
        <Grid item sm={3}>
          <FilterBy
            getDataFunc={() => getInvoiceForm({ status: 1 })}
            value={inputData.form}
            getOptionLabel={(option) => `${option.form} - ${option.series}` || ""}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, form: newValue }))}
            label={t("Mẫu số")}
          />
        </Grid>
        <Grid item sm={4}>
          <TextField
            fullWidth
            value={inputData.customer?.name}
            onChange={(e) => setInputData((prev) => ({ ...prev, customer: { ...prev.customer, name: e.target.value } }))}
            label={t("Đơn vị mua hàng")}
          />
        </Grid>
        <Grid item sm={2}>
          <CustomDatePicker
            format="DD/MM/YYYY"
            label={t("Ngày xuất hóa đơn")}
            value={inputData.valid_date}
            onChange={(value) => setInputData((prev) => ({ ...prev, valid_date: value, saleorder: null }))}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item sm={3}>
          <TextField
            fullWidth
            label={t("Mã số thuế")}
            value={inputData.customer?.tax_code}
            onChange={(e) => setInputData((prev) => ({ ...prev, customer: { ...prev.customer, tax_code: e.target.value } }))}
          />
        </Grid>
        <Grid item sm={12}>
          <TextField
            fullWidth
            label={t("Địa chỉ đơn vị mua hàng")}
            value={inputData.customer?.address}
            onChange={(e) => setInputData((prev) => ({ ...prev, customer: { ...prev.customer, address: e.target.value } }))}
          />
        </Grid>
        <Grid item sm={4}>
          <TextField fullWidth label={t("Hãng bay")} />
        </Grid>
        <Grid item sm={4}>
          <FilterBy
            getDataFunc={() => getSaleType({ status: 1 })}
            triggerSetDefaultFunc={true}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, saletype: option.find((item) => item.code === 3) || null }))}
            value={inputData.saletype}
            label={t("Loại hình bán")}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, saletype: newValue }))}
          />
        </Grid>
        <Grid item sm={4}>
          <FilterBy
            getDataFunc={() => getInventory({ organization_id: user?.organization_id, status: 1 })}
            filter={(option) => option.whtype !== 1 && user?.organization_id === option.organization_id}
            triggerGetDataFunc={Boolean(user)}
            value={inputData.inventory}
            onChange={(e, newValue) =>
              setInputData((prev) => ({
                ...prev,
                inventory: newValue,
                flight: null,
                saleorder: null,
                vehicle: null,
                invoiceproducts: prev.invoiceproducts.map((item) => ({ ...item, vehicle: null, position_no: "" })),
              }))
            }
            label={t("Kho xuất")}
          />
        </Grid>
        <Grid item sm={2}>
          <FilterBy
            disabled={!inputData.inventory}
            getDataFunc={() =>
              getFlight({
                customer_id: inputData.customer.id,
                organization_id: inputData.inventory.organization_id,
                airline_id: inputData.airline?.id,
                status: 1,
              })
            }
            getDataDependencies={[inputData.customer, inputData.inventory, inputData.airline]}
            triggerGetDataFunc={inputData.inventory && inputData.customer}
            value={inputData.flight}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, flight: newValue }))}
            getOptionLabel={(option) => `${option.id} - ${option.flight_no}` || ""}
            label={"Số chuyến bay"}
          />
        </Grid>
        <Grid item sm={2}>
          <TextField label="Tuyến bay" fullWidth value={inputData.flight?.route || ""} disabled />
        </Grid>
        <Grid item sm={2}>
          <TextField label="Đăng bạ tàu bay" fullWidth value={inputData.code_aircraft} onChange={(e) => setInputData((prev) => ({ ...prev, code_aircraft: e.target.value }))} />
        </Grid>
        <Grid item sm={2}>
          <FilterBy
            getDataFunc={() => getAircraft({ status: 1 })}
            value={inputData.aircraft_type}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, aircraft_type: newValue }))}
            label="Chủng máy bay"
          />
        </Grid>
        <Grid item sm={2}>
          <CustomDatePicker
            format="DD/MM/YYYY HH:mm:ss"
            outputFormat="YYYY-MM-DD HH:mm"
            label={t("Giờ bắt đầu")}
            value={inputData.start_time}
            onChange={(value) => setInputData((prev) => ({ ...prev, start_time: value }))}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item sm={2}>
          <CustomDatePicker
            format="DD/MM/YYYY HH:mm:ss"
            outputFormat="YYYY-MM-DD HH:mm"
            label={t("Giờ kết thúc")}
            value={inputData.end_time}
            onChange={(value) => setInputData((prev) => ({ ...prev, end_time: value }))}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item sm={2}>
          <FilterBy
            label={t("Hàng hóa")}
            getDataFunc={() => getProduct({ status: 1 })}
            value={inputData.product}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, product: newValue }))}
          />
        </Grid>
        <Grid item sm={2}>
          <FilterBy
            label={t("Loại tiền")}
            getDataFunc={() => getCurrency({ status: 1 })}
            getOptionLabel={(option) => option?.code}
            value={inputData.currency}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, currency: newValue }))}
          />
        </Grid>
        <Grid item sm={2}>
          <TextField fullWidth label={t("Giá bán/USG")} value={inputData.price_unit} onChange={(e) => setInputData((prev) => ({ ...prev, price_unit: e.target.value }))} />
        </Grid>
        <Grid item sm={6}>
          <TextField fullWidth label="Ghi chú" value={inputData.note} onChange={(e) => setInputData((prev) => ({ ...prev, note: e.target.value }))} />
        </Grid>
      </Grid>
      <ProductTable inputData={inputData} setInputData={setInputData} />

      <div align="left">
        {/* button is disabled if required field is empty */}
        <ButtonGroup>
          <Button variant="contained" onClick={() => setDialogOpen(true)}>
            {t("Xem trước")}
          </Button>
          <ButtonWithAPICall api={handleSubmit} variant="contained" color="info">
            {t("Tạo phiếu")}
          </ButtonWithAPICall>
        </ButtonGroup>
      </div>
      <Dialog maxWidth={false} fullWidth={true} scroll="body" onClose={() => setDialogOpen(false)} open={dialogOpen}>
        <InvoicePreview data={dataForPreview} />
      </Dialog>
    </div>
  );
}
export default CreateOtherInvoice;

const ProductTable = ({ inputData, setInputData }) => {
  const [t] = useTranslation();
  const productRef = useRef();
  //redux state
  const user = useSelector((state) => state.user.data);

  useEffect(() => {
    inputData.invoiceproducts.forEach((item, index) => {
      handleChangeReceiptProduct(index, "temp", item.temp);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData.method]);

  useEffect(() => {
    productRef.current = inputData.invoiceproducts;
  }, [inputData.invoiceproducts]);
  const handleChangeReceiptProduct = (index, keyName, value) => {
    let newProduct = [...inputData.invoiceproducts];
    newProduct[index][keyName] = value;
    if (["temp", "density", "unit", "meter_before_pump", "meter_after_pump"].includes(keyName)) {
      newProduct[index] = {
        ...newProduct[index],
        lit: "",
        d15: "",
        vcf: "",
        wcf: "",
        l15: "",
        kg: "",
        gallon: "",
      };
      switch (keyName) {
        case "temp":
          newProduct[index].temp_error = newProduct[index].temp < 4.5 || newProduct[index].temp > 52 ? "Temp must be in range 4.5 - 52" : undefined;
          break;
        case "density":
          newProduct[index].density_error = newProduct[index].density < 7000 || newProduct[index].density > 8730 ? "Density must be in range 7000 - 8730" : undefined;
          break;
        default:
          break;
      }
      // kiem tra dieu kien, neu thoa man thi goi api convert
      if (
        newProduct[index].meter_after_pump.toString() &&
        newProduct[index].meter_before_pump.toString() &&
        newProduct[index].unit &&
        newProduct[index].temp &&
        newProduct[index].density &&
        !newProduct[index].temp_error &&
        !newProduct[index].density_error
      ) {
        let { meter_before_pump, meter_after_pump, unit, temp, density } = newProduct[index];
        newProduct[index].loadingState = true;
        postConversion({
          quantity: meter_after_pump - meter_before_pump,
          unit: unit,
          temp: temp,
          density: density / 10000,
          method: inputData.method,
        }).then((res) => {
          if (
            // kiem tra xem du lieu cu co giong du lieu hien tai khong, neu khong giong thi k update
            res.code === 200 &&
            meter_before_pump === productRef.current[index].meter_before_pump &&
            meter_after_pump === productRef.current[index].meter_after_pump &&
            unit === productRef.current[index].unit &&
            temp === productRef.current[index].temp &&
            density === productRef.current[index].density
          ) {
            newProduct = productRef.current;
            newProduct[index] = {
              ...newProduct[index],
              lit: res.data.lit,
              d15: res.data.d15,
              vcf: res.data.vcf,
              wcf: res.data.wcf,
              l15: res.data.l15,
              kg: res.data.kg,
              gallon: res.data.gallon,
              loadingState: undefined,
            };
            setInputData((prev) => ({ ...prev, invoiceproducts: newProduct }));
          }
        });
      }
    }
    setInputData((prev) => ({ ...prev, invoiceproducts: newProduct }));
  };
  return (
    <>
      <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 20, textTransform: "uppercase" }}>{t("Thông tin hàng hóa")}</div>
      <div align="left" style={{ display: "flex", alignItems: "center" }}>
        <ButtonGroup>
          <Button onClick={() => inputData.method !== 1 && setInputData((prev) => ({ ...prev, method: 1 }))} style={{ backgroundColor: inputData.method === 1 ? "lightblue" : "" }}>
            KG = L15 * WCF
          </Button>
          <Button onClick={() => inputData.method !== 2 && setInputData((prev) => ({ ...prev, method: 2 }))} style={{ backgroundColor: inputData.method === 2 ? "lightblue" : "" }}>
            KG = LTT * DENSITY
          </Button>
        </ButtonGroup>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell align="center">Xe tra nạp số</TableCell>
              <TableCell align="center">*Vị trí tra nạp</TableCell>
              <TableCell align="center">Người điều khiển</TableCell>
              <TableCell align="center">Chứng chỉ số</TableCell>
              <TableCell align="center">*Số công tơ đầu</TableCell>
              <TableCell align="center">*Số công tơ cuối</TableCell>
              <TableCell align="center">Khối lượng</TableCell>
              <TableCell align="center">Đơn vị</TableCell>
              <TableCell align="center">°C</TableCell>
              <TableCell align="center">*{t("Tỷ trọng")}</TableCell>
              <TableCell align="center">D15</TableCell>
              <TableCell align="center">VCF</TableCell>
              <TableCell align="center">WCF</TableCell>
              <TableCell align="center">
                {t("Số lượng")} ({t("lit")} 15℃)
              </TableCell>
              <TableCell align="center">{t("Số lượng")} (kg)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {inputData.invoiceproducts?.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <IconButton
                    onClick={() => inputData.invoiceproducts?.length > 1 && setInputData((prev) => ({ ...prev, invoiceproducts: prev.invoiceproducts.filter((i, sub_index) => index !== sub_index) }))}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <FilterBy
                    getDataFunc={() => getVehicle({ organization_id: inputData.inventory?.organization_id, status: 1 })}
                    triggerGetDataFunc={Boolean(inputData.inventory)}
                    value={item.vehicle}
                    sx={{ width: "200px" }}
                    filter={(item) =>
                      item.organization_id === user?.organization_id &&
                      ((item.groupvehicle_code === "00" && inputData.inventory?.whtype === "2") || (item.groupvehicle_code === "01" && inputData.inventory?.whtype == "3"))
                    }
                    disabled={!inputData.inventory}
                    getOptionLabel={(option) => option.license_plate || ""}
                    onChange={(e, newValue) => handleChangeReceiptProduct(index, "vehicle", newValue)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    InputProps={{ style: { width: 200 } }}
                    value={item.position_no}
                    disabled={!inputData.inventory || inputData.inventory?.whtype != 3}
                    onChange={(e) => handleChangeReceiptProduct(index, "position_no", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField InputProps={{ style: { width: 200 } }} fullWidth value={item.driver} onChange={(e) => handleChangeReceiptProduct(index, "driver", e.target.value)} />
                </TableCell>
                <TableCell align="center">
                  <TextField fullWidth InputProps={{ style: { width: 100 } }} value={item.cert_no} onChange={(e) => handleChangeReceiptProduct(index, "cert_no", e.target.value)} />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    type="number"
                    InputProps={{ style: { width: 150 } }}
                    onChange={(e) => handleChangeReceiptProduct(index, "meter_before_pump", e.target.value)}
                    value={item.meter_before_pump}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    type="number"
                    InputProps={{ style: { width: 150 } }}
                    value={item.meter_after_pump}
                    onChange={(e) => handleChangeReceiptProduct(index, "meter_after_pump", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField fullWidth InputProps={{ style: { width: 150 } }} disabled value={Math.round(item.meter_after_pump - item.meter_before_pump)?.toLocaleString()} />
                </TableCell>
                <TableCell align="center">
                  <TextField fullWidth value={item.unit} onChange={(e) => handleChangeReceiptProduct(index, "unit", e.target.value)} select>
                    <MenuItem value={21}>Lit</MenuItem>
                    <MenuItem value={22}>USG</MenuItem>
                  </TextField>
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    inputProps={{ style: { textAlign: "center", width: 50 } }}
                    value={item.temp}
                    error={(item.temp < 4.5 || item.temp > 52) && item.temp !== ""}
                    helperText={item.temp < 4.5 || item.temp > 52 ? "(4-52)" : " "}
                    style={{ paddingTop: 20 }}
                    onChange={(e) => handleChangeReceiptProduct(index, "temp", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    inputProps={{ style: { textAlign: "center", width: 75 } }}
                    value={item.density}
                    error={(item.density < 7001 || item.density > 8730) && item.density !== ""}
                    helperText={item.density < 7001 || item.density > 8730 ? "(7001-8730)" : " "}
                    style={{ paddingTop: 20 }}
                    onChange={(e) => handleChangeReceiptProduct(index, "density", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">{item.d15 && parseFloat(item.d15)?.toFixed(4)}</TableCell>
                <TableCell align="center">{item.vcf && parseFloat(item.vcf)?.toLocaleString()}</TableCell>
                <TableCell align="center">{item.wcf && parseFloat(item.wcf)?.toLocaleString()}</TableCell>
                <TableCell align="center">{Math.round(item.l15)?.toLocaleString()}</TableCell>
                <TableCell align="center">{Math.round(item.kg)?.toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button variant="outlined" onClick={() => setInputData((prev) => ({ ...prev, invoiceproducts: [...prev.invoiceproducts, { ...initialProduct }] }))} style={{ marginTop: 30 }}>
        {t("Thêm hàng hóa")}
      </Button>
    </>
  );
};
